import { Zap } from "lucide-react";

interface UpgradePromptProps {
  feature: string;
  description?: string;
  onViewPlans?: () => void;
}

export default function UpgradePrompt({ feature, description, onViewPlans }: UpgradePromptProps) {
  return (
    <div className="rounded-lg border-2 border-gold/40 bg-gold/5 p-3 flex items-center gap-3">
      <div className="h-8 w-8 rounded-lg bg-gold/15 flex items-center justify-center shrink-0">
        <Zap className="h-4 w-4 text-gold" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-bold text-navy">{feature} requires upgrading your plan.</div>
        {description && <div className="text-xs text-muted-foreground mt-0.5">{description}</div>}
      </div>
      <button
        onClick={onViewPlans}
        className="text-sm font-bold text-gold hover:underline shrink-0"
      >
        View Plans →
      </button>
    </div>
  );
}
